export default "__VITE_PUBLIC_ASSET__07c22e24__"